/*  Copyright (c) 2021
 *   All rights reserved.
 *   Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.
 *  All rights reserved.  2020 WARNING: this file may contain export controlled information.
 */

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { NAMESPACE, RulesEngineActions } from '../rules-engine.reducer';
import { switchMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { of } from 'rxjs';

@Injectable()
export class RulesEffects {

  constructor(private action$: Actions, private localStorage: LocalStorageService) {}

  init$ = createEffect(() =>
    this.action$.pipe(
      ofType(RulesEngineActions.INIT),
      switchMap(() => {
        const local = this.localStorage.get(`${NAMESPACE}`) as any;
        if (local) {
          return of({ type: RulesEngineActions.SET_SELECTED_RULE, payload: local });
        } else {
          return of({ type: RulesEngineActions.KEEP_CURRENT_STATE });
        }
      })
    )
  );

  iniPageState$ = createEffect(() =>
    this.action$.pipe(
      ofType(RulesEngineActions.INIT_PAGESTATE),
      switchMap(() => {
        const local = this.localStorage.get(`${NAMESPACE}-PAGESTATE`) as any;
        if (local) {
          return of({ type: RulesEngineActions.SET_LAST_STATE, payload: local });
        } else {
          return of({ type: RulesEngineActions.KEEP_LAST_STATE });
        }
      })
    )
  );

  saveOnLs$ = createEffect(() =>
    this.action$.pipe(
      ofType(RulesEngineActions.SET_SELECTED_RULE),
      tap((action: any) => {
        this.localStorage.set(`${NAMESPACE}`, action.payload);
      })
    ), { dispatch: false }
  );

  savePageStateOnLs$ = createEffect(() =>
    this.action$.pipe(
      ofType(RulesEngineActions.SET_LAST_STATE),
      tap((action: any) => {
        this.localStorage.set(`${NAMESPACE}-PAGESTATE`, action.payload);
      })
    ), { dispatch: false }
  );
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
      2020 WARNING: this file may contain export controlled information.*/
